import { css } from '@emotion/css'
import { colors, spacing, mediaQueryHelper, breakpoint } from '@offerzen/pinata-shame'

import { navbarHeight } from '../Navbar'

const TOOLBAR_HEIGHT = 50

const styles = {
  toolbarWrapper: css({
    backgroundColor: colors.white,
  }),

  toolbar: css({
    padding: 0,
    height: TOOLBAR_HEIGHT,
  }),

  notificationWrapper: css({
    position: 'sticky',
    top: navbarHeight,

    [mediaQueryHelper(breakpoint.tablet)]: {
      top: 0,
    },
  }),

  notification: css({
    borderRadius: 'unset',
    borderRight: 'unset',
    borderLeft: 'unset',
    width: '100%',
    alignItems: 'center',

    [mediaQueryHelper(breakpoint.desktop)]: {
      justifyContent: 'center',
    },
  }),

  container: css({
    padding: 0,

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginTop: spacing.extraLarge,
      marginBottom: spacing.extraLarge,
    },
  }),
}

export default styles
